import { bookingOperations, bookingTypes } from '../../store/booking';
import { call, put, takeLatest } from 'redux-saga/effects';
import { DAS_GET_TICKET_CUSTOMER_DATA_CHANGES_FAILED } from '../../constants/errors';
import { createError } from '../../store/errors';
import { getTicketCustomerDataChanges } from '../../api/booking';

const { GET_TICKET_CUSTOMER_DATA_CHANGES } = bookingTypes;

export const performGetTicketCustomerDataChanges = function* performGetTicketCustomerDataChanges({
  payload,
}) {
  const { getTicketCustomerDataChangesSuccess } = bookingOperations;
  const { bookingRef } = payload;

  try {
    const data = yield call(getTicketCustomerDataChanges, bookingRef);

    yield put(getTicketCustomerDataChangesSuccess(data, bookingRef));
  } catch (error) {
    yield put(
      createError({
        code: DAS_GET_TICKET_CUSTOMER_DATA_CHANGES_FAILED,
      }),
    );
  }
};

export default takeLatest(
  GET_TICKET_CUSTOMER_DATA_CHANGES,
  performGetTicketCustomerDataChanges,
);
